<template>
    <div class="idx-property-details-comp">
        <div class="container">
            <div class="new_property_details_bredc_content">
                <ul>
                    <li><a :href="baseurl">Home</a></li>
                    <li>
                        <a :href="baseurl + '/new-construction'">New Constructions</a>
                    </li>
                    <li>
                        <a :href="baseurl + '/new-construction/search-home'">Properties</a>
                    </li>
                    <li class="text-danger">{{ property_name }}</li>
                    <!-- <li class="text-primary d-block d-sm-none">{{ short_property_name }}</li> -->
                </ul>
            </div>
            <div class="row">
                <div class="col">
                    <div class="mb-3">
                        <h1 class="h2">{{ property_name }}</h1>
                        <p v-if="property_details.community" class="mb-0">
                            Community : {{ property_details.community }}
                        </p>
                        <p v-if="parentAddress">
                            Address : {{ parentAddress }}
                        </p>
                    </div>
                </div>
                <div class="col-auto">
                    <div class="d-flex align-items-center g-2">
                        <a href="javascript:void(0)" class="mr-2" @click="openShareModal"><img
                                src="/images/property-details/solar-share-linear.png" alt="" /></a>
                        <a href="javascript:void(0)" @click="handleFavorite">
                            <span key="favorite" v-if="isFav"><i class="fas fa-heart text-danger"></i></span>
                            <span key="unfavorite" v-else><i class="far fa-heart text-danger"></i></span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="container property-slider__container">
            <div :id="'property-img'" class="carousel" data-ride="carousel" data-interval="false">
                <ol class="carousel-indicators">
                    <li :data-target="'#property-img'" :data-slide-to="index" :class="{ active: index === 0 }"
                        v-for="(img, index) in sliderImages">

                    </li>
                </ol>
                <div class="carousel-inner">
                    <div class="carousel-item" v-for="(img, index) in sliderImages" :class="{ active: index === 0 }">
                        <img class="d-block w-100" :src="img.file_url" alt="Property" />
                    </div>
                </div>
                <a class="carousel-control-prev" :href="'#property-img'" role="button" data-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="sr-only">Previous</span>
                </a>
                <a class="carousel-control-next" :href="'#property-img'" role="button" data-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="sr-only">Next</span>
                </a>
            </div>
            <div v-if="constructionStatus" class="bottom-label bottom-label-left">
                Status {{ constructionStatus }}
            </div>
            <div class="bottom-label bottom-label-right" v-if="property_info_other_images.length > 0">
                <button class="btn btn-sm photo-player-btn" data-fancybox="gallery"
                    :data-src="property_info_other_images[0].file_url">
                    + Show all {{ property_info_other_images.length }} Photos
                    <img :src="property_info_other_images[0].file_url" class="img-fluid slider_image"
                        @error="handleImageError" v-show="false" />
                </button>
            </div>
        </div>
        <div class="container price-container-mobile d-block d-sm-none">
            <h2>
                {{ property_price ? property_price : "Register Now" }}
                {{ property_price && is_parent ? "+" : "" }}
            </h2>
        </div>
        <div class="container main-info-container">
            <div class="main-info">
                <div class="main-info__item">
                    <h5>
                        {{ bed }}
                        <span v-if="addtional_bedrooms">
                            + {{ addtional_bedrooms }}</span>
                    </h5>
                    <p>Bedrooms</p>
                </div>
                <div class="main-info__item">
                    <h5>{{ bath }}</h5>
                    <p>Bathrooms</p>
                </div>
                <div class="main-info__item">
                    <h5>{{ garage }}</h5>
                    <p>Garage</p>
                </div>
                <div class="main-info__item">
                    <h5>{{ sqft_area }}</h5>
                    <p>Squarefoot</p>
                </div>
            </div>
            <div class="price">
                <h2>{{ property_price }}</h2>
            </div>
        </div>
        <div class="property-tabs-wrapper">
            <nav class="container">
                <ul>
                    <li>
                        <a href="#property-overview" :class="{
                        active: currentTabId === '#property-overview',
                    }" @click="handleTabChange">Overview</a>
                    </li>
                    <li>
                        <a href="#explore-neighborhood" :class="{
                        active:
                            currentTabId === '#explore-neighborhood',
                    }" @click="handleTabChange">Map</a>
                    </li>
                    <li>
                        <a href="#property-details-section" :class="{
                        active:
                            currentTabId ===
                            '#property-details-section',
                    }" @click="handleTabChange">Property Details</a>
                    </li>
                    <!-- <li>
                        <a href="#facts-features-section" :class="{ 'active': currentTabId === '#facts-features-section' }"
                            @click="handleTabChange">Facts & Feature</a>
                    </li> -->
                    <li v-if="virtual_tour">
                        <a href="#virtual_tour" :class="{ active: currentTabId === '#virtual_tour', }"
                            @click="handleTabChange">Virtual Tour</a>
                    </li>
                    <li>
                        <a href="#Floor_plan" v-if="property_details.property_images &&
                        property_details.property_images.length
                        " :class="{ active: currentTabId === '#Floor_plan', }" @click="handleTabChange">Layout</a>
                    </li>
                </ul>
            </nav>
        </div>
        <!-- For Mobile View -->
        <div class="container d-flex d-sm-none justify-content-end">
            <button class="fill-up-btn btn" @click="openScheduleAppointmentForm">
                <div class="img-container">
                    <img src="/images/property-details/fluent-emoji_house-with-garden.png" alt="Home" />
                </div>
            </button>
        </div>
        <div class="container tabs-content-layout">
            <div class="left-section">
                <!-- ------------------------ Property Overview Section ----------------------- -->
                <section id="property-overview">
                    <h3>Why {{ property_name }} ?</h3>
                    <ul class="property-overview__features">
                        <li>
                            <label>Type</label>
                            <p>{{ home_type }}</p>
                        </li>
                        <li>
                            <label>Bathrooms</label>
                            <p>{{ bath }}</p>
                        </li>
                        <li>
                            <label>Bedrooms</label>
                            <p>{{ bed }}</p>
                        </li>
                        <li>
                            <label>Age</label>
                            <p>{{ property_age }}</p>
                        </li>
                        <li>
                            <label>Status</label>
                            <p>{{ constructionStatus }}</p>
                        </li>
                        <li>
                            <label>Garage</label>
                            <p>{{ garage }}</p>
                        </li>
                        <li>
                            <label>Area</label>
                            <p>{{ sqft_area }} Sqft</p>
                        </li>
                        <li>
                            <label>Frontage</label>
                            <p>{{ property_details.plan_properties[0].front_age || "No data" }}</p>
                        </li>
                    </ul>
                    <div class="about-property-wrapper" v-if="property_details.plan_properties[0].detailed_description">
                        <p class="about-property" ref="aboutPropertyRef" :class="{ full: showFullDescription }"
                            v-html="property_details.plan_properties[0].description"></p>
                        <button class="btn read-more-btn" v-if="hasMoreDescription"
                            @click="showFullDescription = !showFullDescription">
                            <div v-if="showFullDescription" key="less">
                                <span class="text-primary">Read Less about the property
                                </span>
                                <i class="fas fa-caret-up"></i>
                            </div>
                            <div v-else key="more">
                                <span class="text-primary">Read more about the property
                                </span>
                                <i class="fas fa-caret-down"></i>
                            </div>
                        </button>
                    </div>
                </section>

                <!-- ---------------------- Explore Neighborhood Section ---------------------- -->
                <section id="explore-neighborhood">
                    <h3 class="mb-4">Explore Neighborhood - Map View</h3>
                    <div class="row align-items-lg-center">
                        <div class="col-lg-7">
                            <div class="map-view">
                                <iframe :src="'https://maps.google.com/maps?q=+' +
                        street_address_map +
                        '&hl=en&z=15&amp;output=embed&'
                        " style="border: 0" allowfullscreen="" loading="lazy"
                                    referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>
                        <div class="col-lg-5">
                            <ul class="neighborhood-features mt-5 mt-lg-0">
                                <li class="circle-icon-with-title">
                                    <div class="icon-wrapper">
                                        <img src="/images/property-details/neighborhood/fluent-emoji_bus-stop.png"
                                            alt="Bus Stop" />
                                    </div>
                                    <p>Commute</p>
                                </li>
                                <li class="circle-icon-with-title">
                                    <div class="icon-wrapper">
                                        <img src="/images/property-details/neighborhood/fluent-emoji_bank.png"
                                            alt="Bus Stop" />
                                    </div>
                                    <p>Banks</p>
                                </li>
                                <li class="circle-icon-with-title">
                                    <div class="icon-wrapper">
                                        <img src="/images/property-details/neighborhood/fluent-emoji_movie-camera.png"
                                            alt="Cinemas" />
                                    </div>
                                    <p>Cinemas</p>
                                </li>
                                <li class="circle-icon-with-title">
                                    <div class="icon-wrapper">
                                        <img src="/images/property-details/neighborhood/fluent-emoji_evergreen-tree.png"
                                            alt="Evergreen Tree" />
                                    </div>
                                    <p>Parks</p>
                                </li>
                                <li class="circle-icon-with-title">
                                    <div class="icon-wrapper">
                                        <img src="/images/property-details/neighborhood/fluent-emoji_shopping-bags.png"
                                            alt="Shopping Bags" />
                                    </div>
                                    <p>Shopping</p>
                                </li>
                                <li class="circle-icon-with-title">
                                    <div class="icon-wrapper">
                                        <img src="/images/property-details/neighborhood/fluent-emoji_pot-of-food.png"
                                            alt="Food" />
                                    </div>
                                    <p>Food</p>
                                </li>
                                <li class="circle-icon-with-title">
                                    <div class="icon-wrapper">
                                        <img src="/images/property-details/neighborhood/fluent-emoji_medical-symbol.png"
                                            alt="Food" />
                                    </div>
                                    <p>Hospitals</p>
                                </li>
                                <li class="circle-icon-with-title">
                                    <div class="icon-wrapper">
                                        <img src="/images/property-details/neighborhood/fluent-emoji_ferris-wheel.png"
                                            alt="Ferris Wheel" />
                                    </div>
                                    <p>Attractions</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </section>

                <!-- ---------------------- Amenities Section ---------------------- -->
                <section id="amenities-section" v-if="getAllAmenities.length">
                    <h3 class="mb-4">Amenities</h3>
                    <ul class="amenities-list m-0">
                        <li class="circle-icon-with-title" v-for="amenity in getAllAmenities" :key="amenity">
                            <div class="icon-wrapper">
                                <img :src="amenity | aminityIcon" :alt="amenity" />
                            </div>
                            <p>{{ amenity }}</p>
                        </li>
                    </ul>
                </section>
                <section class="premium_info_desk" v-if="property_details.description">
                    <div class="lot_premium">
                        <h3 class="lot_premium_header">Lot Premiums</h3>
                        <p v-html="lotPremiumDescription"></p>
                    </div>
                </section>
                <section class="premium_info_desk" v-if="property_details.elevation_premium">
                    <div class="lot_premium">
                        <h3 class="lot_premium_header">Elevation Premiums</h3>
                        <p v-html="elevationPremiumDescription"></p>
                    </div>
                </section>
                <section id="deposite_structure" v-if="depositeDescription">
                    <h3 class="mb-4">Deposite Structure</h3>
                    <div v-html="depositeDescription" class="deposite_structure_container"></div>
                </section>
                <section v-if="property_details.nearby_school" class="nearby-schools-section border-bottom-0 pb-3">
                    <h3>Nearby Schools</h3>
                    <ul>
                        <li v-for="school in property_details.nearby_school">
                            <h4>{{ school.school_name }}</h4>
                            <p>{{ school.school_address }}</p>
                            <p>{{ school.school_category }}</p>
                        </li>
                    </ul>
                </section>

                <!-- ------------------------ Property Details Section ------------------------ -->
                <section id="property-details-section">
                    <h3 class="mb-3">Property Details</h3>
                    <ul>
                        <template v-for="(value, key) in propertyDetailsSectionsData">
                            <li v-if="value" :key="key">
                                {{ key }} : <b>{{ value }}</b>
                            </li>
                        </template>
                    </ul>
                </section>

                <Section id="Floor_plan" v-if="property_details.property_images &&
                        property_details.property_images.length
                        ">
                    <h3 class="mb-3">Layout</h3>
                    <div class="Floor_container">
                        <img v-for="(
                                img, index
                            ) in floor_plans" data-fancybox="gallery2" v-fancybox="'group2'" :src="img.file_url"
                            class="Floor_plan_image img-fluid" @error="handleImageError" v-show="true" :key="index" />
                    </div>
                </Section>
                <!-- <Section id="Floor_plan" v-if="property_details.property_images &&
                    property_details.property_images.length
                    ">
                    <h3 class="mb-3">Layout</h3>
                    <FancyBox :options="fancyboxOptions">

                        <a :href='img.file_url' v-for="(
                                img, index
                            ) in floor_plans" data-fancybox="floorImage">
                            <img :src="img.file_url" alt="Floorimage" class="img-fluid floor_image"
                                @error="handleImageError" v-show="true" :key="index" width="100" height="100">
                        </a>
                    </FancyBox>
                </Section> -->
                <!-- ------------------------ Virtual Tour Section ------------------------ -->
                <section id="virtual_tour" v-if="virtual_tour">

                    <h3>Virtual Tour</h3>
                    <div class="video_controlers">
                        <div class="video_play_button" v-if="!this.videoPlayer">
                            <svg width="110" height="110" viewBox="0 0 110 110" fill="none"
                                xmlns="http://www.w3.org/2000/svg" @click="togglePlay">
                                <circle opacity="0.7" cx="55" cy="55" r="55" fill="#FEFFF1" />
                                <circle cx="55" cy="55" r="44" fill="#FEFFF1" />
                                <path
                                    d="M70.5 55.2508C70.501 55.6752 70.3922 56.0927 70.1841 56.4626C69.976 56.8325 69.6758 57.1422 69.3125 57.3617L46.8 71.1336C46.4204 71.366 45.9857 71.4929 45.5407 71.5011C45.0958 71.5094 44.6566 71.3987 44.2688 71.1805C43.8845 70.9657 43.5645 70.6524 43.3415 70.2729C43.1185 69.8933 43.0006 69.4613 43 69.0211V41.4805C43.0006 41.0403 43.1185 40.6082 43.3415 40.2287C43.5645 39.8492 43.8845 39.5359 44.2688 39.3211C44.6566 39.1029 45.0958 38.9922 45.5407 39.0004C45.9857 39.0087 46.4204 39.1356 46.8 39.368L69.3125 53.1398C69.6758 53.3593 69.976 53.6691 70.1841 54.039C70.3922 54.4089 70.501 54.8264 70.5 55.2508Z"
                                    fill="#E11F26" />
                            </svg>
                        </div>
                        <video id="video" :src="virtual_tour" ref="videoPlayer" type="video/mp4"
                            :controls="this.videoPlayer"></video>
                    </div>
                </section>
                <!-- ------------------------ Available Floor Plans Section ------------------------ -->
                <section id="available-floor-plans" v-if="availablePlans && availablePlans.length">
                    <h3 class="mb-3">Different Models</h3>
                    <ul class="plan-list">
                        <a :href="plan.plan_details_url" v-for="plan in availablePlans">
                            <img :src="plan.img" alt="" />
                            <div class="plan-info">
                                <p>
                                    {{ plan.property_name }}
                                    {{
                        plan.list_price
                            ? `- ${plan.list_price}`
                            : null
                    }}
                                </p>
                                <ul class="plan-info__overview">
                                    <li>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26"
                                            viewBox="0 0 25 26" fill="none">
                                            <path
                                                d="M19.793 7.79171H14.4596C12.8028 7.79171 11.4596 9.13485 11.4596 10.7917V12.0834C11.4596 13.7402 10.1165 15.0834 8.45963 15.0834H6.1263C4.46945 15.0834 3.1263 13.7402 3.1263 12.0834V6.75004C3.1263 6.17474 2.65993 5.70837 2.08464 5.70837C1.50934 5.70837 1.04297 6.17474 1.04297 6.75004V20.2917C1.04297 20.867 1.50934 21.3334 2.08464 21.3334C2.65993 21.3334 3.1263 20.867 3.1263 20.2917V19.7709C3.1263 18.9079 3.82586 18.2084 4.6888 18.2084H20.3138C21.1767 18.2084 21.8763 18.9079 21.8763 19.7709V20.2917C21.8763 20.867 22.3427 21.3334 22.918 21.3334C23.4933 21.3334 23.9596 20.867 23.9596 20.2917V11.9584C23.9596 10.8533 23.5206 9.7935 22.7392 9.0121C21.9578 8.23069 20.898 7.79171 19.793 7.79171ZM7.29297 14.0417C8.12177 14.0417 8.91663 13.7125 9.50268 13.1264C10.0887 12.5404 10.418 11.7455 10.418 10.9167C10.418 10.0879 10.0887 9.29305 9.50268 8.707C8.91663 8.12095 8.12177 7.79171 7.29297 7.79171C6.46417 7.79171 5.66931 8.12095 5.08326 8.707C4.49721 9.29305 4.16797 10.0879 4.16797 10.9167C4.16797 11.7455 4.49721 12.5404 5.08326 13.1264C5.66931 13.7125 6.46417 14.0417 7.29297 14.0417Z"
                                                fill="#323232" />
                                        </svg>
                                        {{
                            plan.bedroom
                                ? `${plan.bedroom} Beds`
                                : "N/A"
                        }}
                                    </li>
                                    <li>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26"
                                            viewBox="0 0 25 26" fill="none">
                                            <path
                                                d="M22.3945 15.0834C22.1069 15.0834 21.8737 15.3166 21.8737 15.6042V16.125C21.8737 17.835 21.0504 19.3526 19.7741 20.3009C19.4051 20.5751 19.1919 21.032 19.3038 21.4778L19.4783 22.1733C19.6368 22.8047 19.1465 23.4167 18.4956 23.4167C18.0367 23.4167 17.629 23.1044 17.5177 22.6592L17.3756 22.0908C17.2643 21.6457 16.8643 21.3334 16.4054 21.3334H8.59197C8.13311 21.3334 7.73312 21.6457 7.62183 22.0908L7.47973 22.6592C7.36844 23.1044 6.96067 23.4167 6.5018 23.4167C5.85085 23.4167 5.36063 22.8047 5.51909 22.1733L5.69344 21.4785C5.80543 21.0323 5.59177 20.5752 5.22237 20.301C4.67871 19.8975 4.21709 19.39 3.86577 18.8054C3.3794 17.996 3.12285 17.0693 3.1237 16.125V15.6042C3.1237 15.3166 2.89051 15.0834 2.60286 15.0834C2.31522 15.0834 2.08203 14.8502 2.08203 14.5625V14C2.08203 13.4478 2.52975 13 3.08203 13H19.832C20.3843 13 20.832 12.5523 20.832 12V5.70837C20.832 5.43211 20.7223 5.16716 20.5269 4.9718C20.3316 4.77645 20.0666 4.66671 19.7904 4.66671C19.5008 4.66671 19.25 4.77614 19.0627 4.95386C18.7839 5.21851 18.9468 5.6403 19.1789 5.94671C19.3751 6.20562 19.5282 6.49651 19.6322 6.80862C19.8068 7.33259 19.3426 7.79171 18.7904 7.79171H14.5404C13.9881 7.79171 13.5253 7.33291 13.699 6.80866C13.8508 6.35064 14.1081 5.92959 14.4557 5.582C15.0417 4.99595 15.8366 4.66671 16.6654 4.66671C16.7715 4.66671 16.8652 4.59935 16.9062 4.50148C17.3768 3.37942 18.4888 2.58337 19.7904 2.58337C20.6192 2.58337 21.414 2.91261 22.0001 3.49867C22.5861 4.08472 22.9154 4.87957 22.9154 5.70837V14.5625C22.9154 14.8502 22.6822 15.0834 22.3945 15.0834Z"
                                                fill="#323232" />
                                        </svg>
                                        {{
                            plan.bathroom
                                ? `${plan.bathroom} Baths`
                                : "N/A"
                        }}
                                    </li>
                                    <li>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26"
                                            viewBox="0 0 25 26" fill="none">
                                            <path
                                                d="M2.08203 7.53121C2.08203 6.77147 2.38383 6.04286 2.92105 5.50564C3.45826 4.96843 4.18688 4.66663 4.94661 4.66663H20.0508C20.8105 4.66663 21.5391 4.96843 22.0763 5.50564C22.6136 6.04286 22.9154 6.77147 22.9154 7.53121V18.4687C22.9154 18.8449 22.8413 19.2174 22.6973 19.5649C22.5534 19.9125 22.3424 20.2283 22.0763 20.4943C21.8103 20.7603 21.4946 20.9713 21.147 21.1152C20.7995 21.2592 20.427 21.3333 20.0508 21.3333H4.94661C4.57043 21.3333 4.19793 21.2592 3.85039 21.1152C3.50284 20.9713 3.18705 20.7603 2.92105 20.4943C2.65505 20.2283 2.44404 19.9125 2.30008 19.5649C2.15613 19.2174 2.08203 18.8449 2.08203 18.4687V7.53121ZM17.4779 8.02079C17.3315 7.87424 17.1329 7.79181 16.9258 7.79163H14.3216C14.1144 7.79163 13.9157 7.87394 13.7692 8.02045C13.6227 8.16696 13.5404 8.36568 13.5404 8.57288C13.5404 8.78008 13.6227 8.97879 13.7692 9.1253C13.9157 9.27182 14.1144 9.35413 14.3216 9.35413H15.0404L13.2487 11.1448C13.1719 11.2163 13.1104 11.3025 13.0677 11.3984C13.025 11.4942 13.002 11.5976 13.0002 11.7025C12.9983 11.8074 13.0176 11.9116 13.0569 12.0089C13.0962 12.1062 13.1547 12.1946 13.2289 12.2687C13.3031 12.3429 13.3914 12.4014 13.4887 12.4407C13.586 12.48 13.6902 12.4993 13.7951 12.4975C13.9 12.4956 14.0034 12.4726 14.0993 12.4299C14.1951 12.3872 14.2813 12.3257 14.3529 12.2489L16.1445 10.4583V11.177C16.1445 11.3842 16.2268 11.583 16.3734 11.7295C16.5199 11.876 16.7186 11.9583 16.9258 11.9583C17.133 11.9583 17.3317 11.876 17.4782 11.7295C17.6247 11.583 17.707 11.3842 17.707 11.177V8.57288C17.7069 8.36575 17.6244 8.16716 17.4779 8.02079ZM8.07162 18.2083H10.6768C10.884 18.2083 11.0827 18.126 11.2293 17.9795C11.3758 17.833 11.4581 17.6342 11.4581 17.427C11.4581 17.2198 11.3758 17.0211 11.2293 16.8746C11.0827 16.7281 10.884 16.6458 10.6768 16.6458H9.95807L11.7497 14.8541C11.892 14.7067 11.9706 14.5093 11.9688 14.3045C11.9669 14.0996 11.8846 13.9037 11.7397 13.759C11.5948 13.6142 11.3988 13.5321 11.194 13.5304C10.9891 13.5287 10.7918 13.6076 10.6445 13.75L8.85287 15.5395V14.8208C8.85287 14.6136 8.77055 14.4149 8.62404 14.2684C8.47753 14.1219 8.27882 14.0395 8.07162 14.0395C7.86441 14.0395 7.6657 14.1219 7.51919 14.2684C7.37267 14.4149 7.29037 14.6136 7.29037 14.8208V17.425C7.29037 17.6322 7.37267 17.8309 7.51919 17.9774C7.6657 18.1239 7.86441 18.2062 8.07162 18.2062V18.2083Z"
                                                fill="#323232" />
                                        </svg>
                                        {{
                            plan.sqft_area
                                ? `${plan.sqft_area} Sqft`
                                : "N/A"
                        }}
                                    </li>
                                </ul>
                            </div>
                            <a :href="plan.plan_details_url" class="plan-action"><i
                                    class="fa-solid fa-angle-right"></i></a>
                        </a>
                    </ul>
                </section>
            </div>

            <aside class="right-section">
                <button class="fill-up-btn btn" @click="openScheduleAppointmentForm">
                    <div class="img-container">
                        <img src="/images/property-details/fluent-emoji_house-with-garden.png" alt="Home" />
                    </div>
                    <span>
                        Hurry Up!<br />
                        Click here to schedule an appointment!
                    </span>
                </button>
                <section class="premium_info" v-if="property_details.description || property_details.elevation_premium">
                    <div class="elevation_premium" v-if="elevationPremiumDescription">
                        <h1 class="elevation_premium_header">Elevation Premium</h1>
                        <p v-html="elevationPremiumDescription"></p>
                    </div>
                    <div class="lot_premium" v-if="lotPremiumDescription">
                        <h1 class="lot_premium_header">Lot Premiums</h1>
                        <p v-html="lotPremiumDescription"></p>
                    </div>
                </section>
                <!-- <a
                    href="/find-your-home-value"
                    class="info-blue-card instant-offer-card"
                >
                    <div class="d-flex flex-column pr-3">
                        <p class="mb-1">Instant offer for your Home?</p>
                        <small
                            >Approximate value based on similar homes in the
                            area.</small
                        >
                    </div>
                    <img
                        src="/images/property-details/fluent-emoji_money-bag.png"
                        alt=""
                    />
                </a> -->

                <!-- <a
                    href="/buying-option"
                    class="info-blue-card instant-offer-card"
                >
                    <div class="d-flex flex-column">
                        <p class="mb-1">
                            Down Payment Assistance for your Home?
                        </p>
                        <small
                            >Transform your down payment into 20% or more with
                            the help from RedBuyers.</small
                        >
                    </div>
                    <img
                        src="/images/property-details/fluent-emoji_money-with-wings.png"
                        alt=""
                    />
                </a> -->

                <!-- <a
                    href="#"
                    data-toggle="modal"
                    data-target="#ownershipInfoModal"
                    class="info-blue-card co-investment-card mb-0"
                >
                    <div class="d-flex flex-column">
                        <p class="mb-1">Co-investment at 1/8th Cost!</p>
                        <small>Min ROI 25%. Click to learn more!</small>
                    </div>
                    <img
                        src="/images/property-details/co-investment.png"
                        alt="Co-Investment"
                        width="80x"
                    />
                </a> -->
            </aside>
        </div>

        <section class="container pb-0" v-if="sameFloorPlans && sameFloorPlans.length">
            <h3 class="mb-30">Inventory sale</h3>
            <div class="common-property-list-grid">
                <common-property-card v-for="property in sameFloorPlans" :key="property.id" :property_details="property"
                    :user_id="user_id" :userFavProperties="userFavProperties" @onFavoriteSuccess="handleFavoriteSuccess"
                    type="NEW_CONSTRUCTION" />
            </div>
        </section>

        <section class="container pb-0" v-if="availabeSimmilarPlans && availabeSimmilarPlans.length">
            <h3 class="mb-30">Similar Houses</h3>
            <div class="common-property-list-grid">
                <common-property-card v-for="property in availabeSimmilarPlans" :key="property.id"
                    :property_details="property" :user_id="user_id" :userFavProperties="userFavProperties"
                    @onFavoriteSuccess="handleFavoriteSuccess" type="NEW_CONSTRUCTION" />
            </div>
        </section>

        <section class="container pb-0" v-if="featuredDevelopments && featuredDevelopments.length">
            <h3 class="mb-30">{{ featuredProperty }}</h3>
            <div class="common-property-list-grid">
                <common-property-card v-for="property in featuredDevelopments" :key="property.id"
                    :property_details="property" :user_id="user_id" :userFavProperties="userFavProperties"
                    @onFavoriteSuccess="handleFavoriteSuccess" type="NEW_CONSTRUCTION" />
            </div>
        </section>

        <schedule-appointment-modal :streetAddress="street_address" :close="true"></schedule-appointment-modal>

        <share-property-modal v-if="loggedInUserEmail" ref="share-property-modal" :properties="[sharePropertyDetails]"
            :senderEmail="loggedInUserEmail" @onSuccess="handleShareSuccess"></share-property-modal>

        <auth-modal ref="authModal" :initialView="initialAuthView" @loginSuccess="loginSuccess"></auth-modal>

        <div v-show="false">
            <a data-fancybox="gallery" :data-src="item.file_url"
                v-for="(item, index) in property_info_other_images.slice(1)" :key="'property-fancybox-' + index">
                <img :src="item.file_url" class="img-fluid" @error="handleImageError" />
            </a>
        </div>
        <ownership-info-modal v-if="only_property_price" :price="only_property_price"></ownership-info-modal>
    </div>
</template>

<script>
import { getAmenityIcon } from "../../../utils/amenities";
import { getUserFavPropertiesIds } from "../../../utils/app";
import AuthModal, { VIEWS } from "../../AuthModal/AuthModal.vue";
import SharePropertyModal from "../../SharePropertyModal.vue";
import ScheduleAppointmentModal from "../ScheduleAppointmentModal.vue";
import OwnershipInfoModal from "../ownership-info-modal.vue";
import CommonPropertyCard from "../../../pages/PropertyCard/CommonPropertyCard/CommonPropertyCard.vue";
import $ from "jquery";
export default {
    name: "NewConstructionDetails",
    components: {
        "schedule-appointment-modal": ScheduleAppointmentModal,
        "share-property-modal": SharePropertyModal,
        "auth-modal": AuthModal,
        "ownership-info-modal": OwnershipInfoModal,
        "common-property-card": CommonPropertyCard,
    },
    props: {
        info: {},
        baseurl: {
            default: "",
        },
        is_logged_in: {
            default: "false",
        },
        previous_url: {
            default: "",
        },
        is_message_share: {
            default: "true",
        },
        user_id: {
            default: "",
        },
        user_email: {
            default: "",
        },
        developments: {
            default: "",
        },
        same_floor_plan: {
            default: "",
        },
        diffrent_floor_plans: {
            default: "",
        },
    },
    data() {
        return {
            fancyboxOptions: {
                // Your other options
                Zoom: {
                    enabled: true,
                    click: false,
                    wheel: 'auto',
                    pinch: true,
                    mode: 'inside',
                    maxRatio: 5,
                },
                Image: {
                    width: '75%',
                    height: '75%',
                },
            },
            id: null,
            property_details: {},
            featuredDevelopments: [],
            currentTabId: "#property-overview",
            favourite_properties: [],
            property_photos: [],
            floor_plans: [],
            logged_in: false,
            prev_ul: "",
            hasMoreDescription: false,
            showFullDescription: false,
            low_avg_price: "",
            high_avg_price: "",
            sold_property: [],
            related_properties: [],
            isSimilarPropertiesLoading: true,
            skeletonList: [1, 2, 3, 4],
            userFavSoldProperties: [],
            userFavProperties: [],
            isFav: false,
            initialAuthView: VIEWS.LOGIN_FORM,
            loggedInUserEmail: "",
            loggedInUserId: "",
            sameFloorPlans: [], // Inventory sale
            differentFloorPlans: [], // Similar Houses
            // property_floor_images: false, // floor plan images
            videoPlayer: false
        };
    },
    mounted() {
        getAmenityIcon("");
        this.property_details = JSON.parse(this.info);
        this.differentFloorPlans = JSON.parse(this.diffrent_floor_plans).filter(
            (item) => !item.is_parent
        );
        this.sameFloorPlans = JSON.parse(this.same_floor_plan).filter(
            (item) => !item.is_parent
        );
        this.featuredDevelopments = JSON.parse(this.developments).filter(
            (item) => !item.is_parent
        );
        this.loggedInUserId = this.user_id;
        this.loggedInUserEmail = this.user_email;

        this.logged_in = this.is_logged_in;
        this.prev_ul = this.previous_url;
        this.fetchUserFavProperties();
        setTimeout(() => {
            this.hasMoreDescription =
                this.$refs?.aboutPropertyRef?.scrollHeight > 90;
        }, 100);

        this.setImageBanner()
        this.floor_plans = this.property_details?.property_images
    },
    created() { },
    methods: {
        togglePlay() {
            const video = this.$refs.videoPlayer;
            this.videoPlayer = true
            video.play()
            console.log('ture', video)
        },
        handleTabChange(e) {
            e.preventDefault();
            if (e.target.hash) {
                this.currentTabId = e.target.hash;
                let offset = $(e.target.hash).offset();
                $("html, body").animate(
                    {
                        scrollTop: offset.top - 70,
                    },
                    500
                );
            }
        },
        openScheduleAppointmentForm() {
            this.$bvModal.show("schedule-appointment-modal");
        },
        handleImageError(event) {
            event.target.src = "/assets/images/no-image-available.png";
        },
        getDifferenceInDays(date1, date2) {
            const diffInMs = Math.abs(date2 - date1);
            return (diffInMs / (1000 * 60 * 60 * 24)) | this.round_off;
        },
        getDifferenceInHours(date1, date2) {
            const diffInMs = Math.abs(date2 - date1);
            return (diffInMs / (1000 * 60 * 60)) | this.round_off;
        },
        fetchUserFavProperties() {
            getUserFavPropertiesIds(
                this.loggedInUserId,
                "new-construction"
            ).then((res) => {
                this.userFavProperties = res;
                this.isFav = this.userFavProperties.includes(
                    this.property_details?.id
                );
            });
        },
        handleFavoriteSuccess(res) {
            if (this.userFavProperties.includes(res.id)) {
                this.userFavProperties = this.userFavProperties.filter(
                    (propertyId) => propertyId !== res.id
                );
            } else {
                this.userFavProperties = [...this.userFavProperties, res.id];
            }
        },
        handleFavorite() {
            if (!this.loggedInUserId) window.location.href = "/login";
            this.saveFavorite();
        },
        saveFavorite() {
            let endpoint =
                "https://valuation.santhoshmathew.com/api/v1/set-favorite-property";
            const formData = new FormData();
            formData.append("user_id", this.loggedInUserId),
                formData.append("property_id", this.property_details?.id);
            formData.append("property_type", "new-construction");
            axios
                .post(endpoint, formData)
                .then((res) => {
                    console.log("❤️", res);
                    this.isFav = !this.isFav;
                })
                .catch((err) => { });
        },
        openAuthModal() {
            this.$refs.authModal.open();
        },
        loginSuccess(user) {
            console.log({ loginResponse: user });
            this.loggedInUserEmail = user.email;
            if (this.loggedInUserEmail) {
                this.openShareModal();
            }
        },
        openShareModal() {
            if (!this.loggedInUserEmail) {
                this.openAuthModal();
                return;
            } else {
                this.$refs["share-property-modal"]?.open();
            }
        },
        handleShareSuccess() {
            setTimeout(() => {
                this.$refs["share-property-modal"]?.close();
            }, 1000);
        },
        priceFormat(num) {
            try {
                const val = (Math.round(+num * 100) / 100).toFixed();
                if (val) {
                    return (
                        "$" +
                        val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    );
                }
                return null;
            } catch (err) {
                console.log("Price Format Error", err);
                return null;
            }
            return null;
        },
        setImageBanner() {
            const homeType = this.property_details?.home_type.toString();
            const planProperties = this.property_details?.plan_properties[0]?.property_cover_image;
            const elevationImage = this.property_details?.property_elevation_image;
            const properties = ["Detached", "Semi-detached", "Town House"]

            if (!properties.includes(homeType) && planProperties?.length) {
                this.property_photos = planProperties
            } else if (properties.includes(homeType) && elevationImage.length) {
                this.property_photos = elevationImage
            } else {
                this.property_photos = [{ file_url: "/assets/images/no-image-available.png" }]
            }
        },
    },
    computed: {
        featuredProperty() {
            if (this.property_details?.plan_properties[0].property_name) {
                return 'All models from ' + this.property_details?.plan_properties[0].property_name
            }
        },
        property_name() {
            if (this.property_details?.property_name && this.property_details?.plan_properties[0].property_name) {
                return this.property_details?.plan_properties[0].property_name + " - " + this.property_details?.property_name;
            } else {
                return "RedBuyers Property " + this.property_details?.id;
            }
        },
        sliderImages() {
            return this.property_photos?.slice?.(0, 5);
        },
        property_info_other_images() {
            return this.property_photos
        },
        property_price() {
            if (this.property_details?.list_price) {
                return this.priceFormat(this.property_details?.list_price);
            } else {
                return null;
            }

        },
        is_parent() {
            if (+this.property_details?.is_parent === 1) {
                return this.property_details?.is_parent;
            } else {
                return "";
            }
        },
        bed() {
            if (this.property_details?.bedroom) {
                return this.property_details.bedroom;
            } else {
                return "0";
            }
        },
        addtional_bedrooms() {
            if (this.property_details?.additional_bathroom) {
                if (
                    this.property_details.additional_bathroom == "0" ||
                    this.property_details.additional_bathroom === 0
                ) {
                    return 0;
                } else {
                    return this.property_details.additional_bathroom;
                }
            } else {
                return 0;
            }
        },
        bath() {
            if (this.property_details?.bathroom) {
                return this.property_details.bathroom;
            } else {
                return "0";
            }
        },
        sqft_area() {
            if (this.property_details?.sqft_area) {
                let sqft = this.property_details.sqft_area;
                return sqft;
            } else {
                return "No Data";
            }
        },
        building_status() {
            return this.property_details?.building_status;
        },
        parentAddress() {
            let Address = this.property_details?.plan_properties[0]?.street_address;
            return Address;
        },
        constructionStatus() {
            let constructionStat = this.property_details?.plan_properties[0]?.construction_status;
            if (constructionStat) {
                const firstLetter = constructionStat.charAt(0)

                const firstLetterCap = firstLetter.toUpperCase()

                const remainingLetters = constructionStat.slice(1)
                constructionStat = firstLetterCap + remainingLetters
            }

            return constructionStat
        },
        basement() {
            if (this.property_details?.basement) {
                return this.property_details?.basement;
            } else {
                return "N.A";
            }
        },
        garage() {
            // console.table(this.property_details);
            return this.property_details?.garage
                ? this.property_details.garage
                : "0.0";
        },
        home_type() {
            if (this.property_details?.home_type) {
                let home_type = this.property_details.home_type;
                return home_type;
            } else {
                return "N.A";
            }
        },
        property_age() {
            if (this.property_details?.plan_properties[0]?.approx_age) {
                let approx_age = this.property_details?.plan_properties[0]?.approx_age;
                return "Approx " + approx_age + " years old";
            } else {
                return "No Data";
            }
        },
        street_address_map() {
            if (this.property_details?.plan_properties[0]?.street_address) {
                let street_address = this.property_details?.plan_properties[0]?.street_address;
                return street_address;
            } else {
                return null;
            }
        },
        street_address() {
            if (this.property_details?.street_address) {
                let street_address = this.property_details.street_address;
                return street_address;
            } else {
                return null;
            }
        },
        sharePropertyDetails() {
            return {
                link: window.location.href,
                address: `${this.street_address_old}, ${this.city} ${this.county_zip}`,
                beedroom: this.bed,
                bathroom: this.bath,
                garage: this.garage,
                price: this.only_property_price,
            };
        },
        street_address_old() {
            if (this.property_details?.address) {
                let addr = this.property_details.address;
                return addr;
            } else {
                return "N.A";
            }
        },
        city() {
            if (this.property_details?.city) {
                let city = this.property_details.city;
                return city;
            } else {
                return "N/A";
            }
        },
        county_zip() {
            if (this.property_details?.county) {
                let county_city =
                    (this.property_details?.county
                        ? ", " + this.property_details.county
                        : "") +
                    (this.property_details?.zip_code
                        ? ", " + this.property_details.zip_code
                        : "");
                return county_city;
            } else {
                return "N/A";
            }
        },
        only_property_price() {
            if (this.property_details?.list_price) {
                return this.property_details.list_price;
            } else {
                return 0;
            }
        },
        factsFeaturesLeftArray() {
            return this.property_details.factsFeatures?.slice(0, 5);
        },
        factsFeaturesRightArray() {
            return this.property_details.factsFeatures?.slice(5);
        },
        getAllAmenities() {
            let all_amenities = this.property_details?.plan_properties[0]?.amenities || [];
            return all_amenities;
        },
        construction_status() {
            return this.property_details?.construction_status || "N/A";
        },
        propertyDetailsSectionsData() {
            return {
                "Building Type": this.property_details?.plan_properties[0]?.building_type,
                Ownership: this.property_details?.plan_properties[0]?.ownership,
                Community: this.property_details?.plan_properties[0]?.community,
                "Selling Status":
                    +this.property_details?.plan_properties[0]?.is_active === 1
                        ? "Active"
                        : "Inactive",
                "Building Status": this.property_details?.plan_properties[0]?.building_status,
                "Built Year": this.property_details?.plan_properties[0]?.built_year,
                "Sales Started": this.property_details?.plan_properties[0]?.sales_started_at,
                "Construction Status":
                    this.property_details?.plan_properties[0]?.construction_status,
                "Construction Started": this.property_details?.plan_properties[0]?.started_at
                    ? new Date(
                        this.property_details?.plan_properties[0]?.started_at
                    )?.getFullYear?.()
                    : null,
                "Completed In": this.property_details?.completed_at
                    ? new Date(
                        this.property_details?.plan_properties[0]?.completed_at
                    )?.getFullYear?.()
                    : null,
                "Builder(s)": this.property_details?.plan_properties[0]?.seller,
                "Architect(s)": this.property_details?.plan_properties[0]?.architect,
                "Interior Designer(s)":
                    this.property_details?.plan_properties[0]?.interior_designer,
                "Marketing Company": this.property_details?.plan_properties[0]?.marketing_company,
                "Sales Company": this.property_details?.plan_properties[0]?.sales_company,
                "Sales Address": this.property_details?.plan_properties[0]?.sale_address,
                Intersection: this.property_details?.plan_properties[0]?.intersection,
                Units: this.property_details?.plan_properties[0]?.unit,
                Corporation: this.property_details?.plan_properties[0]?.corporation,
                "Actual City": this.property_details?.plan_properties[0]?.actual_city,
                "Lot Size": this.property_details?.lot_size,
                "House Occupy": this.property_details?.plan_properties[0]?.house_occupy,
                "Swimming Pool": +this.property_details?.plan_properties[0]?.swimming_pool ? "Yes" : 'No',
                "Have Parking": +this.property_details?.plan_properties[0]?.have_parking
                    ? "Yes"
                    : null,
            };
        },
        virtual_tour() {
            if (this.property_details?.plan_properties[0]?.virtual_tour) {
                return this.property_details?.plan_properties[0]?.virtual_tour
            }
            return false
        },
        availablePlans() {
            let images = '';
            const homeType = this.property_details?.home_type.toString();
            const planProperties = this.property_details?.plan_properties[0]?.property_cover_image;
            const elevationImage = this.property_details?.property_elevation_image;
            const properties = ["Detached", "Semi-detached", "Town House"]

            if (!properties.includes(homeType) && planProperties?.length) {
                images = planProperties
            } else if (properties.includes(homeType) && elevationImage.length) {
                images = elevationImage
            } else {
                images = [{ file_url: "/assets/images/no-image-available.png" }]
            }
            return this.differentFloorPlans
                ?.filter((item) => !item.is_parent)
                .map((item) => {
                    return {
                        ...item,
                        property_name: item?.plan_properties[0]?.property_name + " - " + item.property_name,
                        img: images[0].file_url,
                        list_price: item?.list_price
                            ? this.priceFormat(item.list_price)
                            : "",
                    }
                });
        },
        availabeSimmilarPlans() {
            return this.sameFloorPlans
        },
        floorPlans() {
            return this.floor_plans
        },
        lotPremiumDescription() {
            let htmlDeposite = "";
            if (this.property_details.description) {
                let Splite = this.property_details?.description?.split("\n");
                for (let senteance of Splite) {
                    const SenteanceWithSpace = senteance.replace(/ /g, '&nbsp;');
                    htmlDeposite += `<p>${SenteanceWithSpace}</p>`;
                }
            }
            return htmlDeposite
        },
        elevationPremiumDescription() {
            let htmlDeposite = "";
            let Splite = this.property_details?.elevation_premium?.split("\n");
            if (Splite) {
                for (let senteance of Splite) {
                    const SenteanceWithSpace = senteance.replace(/ /g, '&nbsp;');
                    htmlDeposite += `<p>${SenteanceWithSpace}</p>`
                }
            }
            return htmlDeposite
        },
        depositeDescription() {
            const homeType = this.property_details?.home_type.toString();
            const ParentDeposite = this.property_details?.plan_properties[0]?.detailed_description;
            const ChildDeposite = this.property_details?.deposit_structure;
            const properties = ["Detached", "Semi-detached", "Town House"]
            let htmlDeposite = '';
            let DepositeArray;
            if (properties.includes(homeType) && ChildDeposite) {
                DepositeArray = ChildDeposite.split("\n\n");
            } else {
                DepositeArray = ParentDeposite.split("\n\n");
            }

            let DepositeSection = "";
            if (DepositeArray) {
                for (let section of DepositeArray) {
                    htmlDeposite = "";
                    let Splite = section.split("\n");
                    if (Splite) {
                        for (let senteance of Splite) {
                            const SenteanceWithSpace = senteance.replace(/ /g, '&nbsp;');
                            htmlDeposite += `<p>${SenteanceWithSpace}</p>`;
                        }
                    }
                    DepositeSection += `<div>${htmlDeposite}</div>`;
                }
                return DepositeSection;
            }
        }
    },
    filters: {
        round_off(num) {
            return (Math.round(num * 100) / 100).toFixed();
        },
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        aminityIcon(aminity) {
            return getAmenityIcon(aminity);
        },
    },
    watch: {
        property_details(newValue, oldValue) {
            if (newValue?.unique_id) {
                this.id = this.property_details.unique_id;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.slider_image {
    object-fit: contain;
}

.idx-property-details-comp {
    --primary-clr: #E11F26;

    ul {
        padding-left: 0;
    }

    .text-primary {
        color: var(--primary-clr);
    }

    .mb-30 {
        margin-bottom: 30px;
    }

    .new_property_details_bredc_content ul li:not(:last-child):before,
    .new_property_details_bredc_content ul li a {
        color: #6e6e73;
    }

    .property-slider__container {
        --space: 20px;
        position: relative;

        .carousel {
            img {
                border-radius: 20px;
                height: 750px;
                max-width: 100%;
                object-fit: fill;
            }

            .carousel-control-prev,
            .carousel-control-next {
                width: 30px;
                height: 30px;
                background-color: rgba(255, 255, 255, 0.65);
                border-radius: 10px;
                top: 50%;
                opacity: 1;
                transition: opacity 0.1s ease-in-out 0s;
                transform: translateY(-50%);

                &>span {
                    display: none;
                }

                &:hover {
                    border: 2px solid var(--primary-clr);
                }
            }

            .carousel-control-next {
                right: var(--space);

                &::before {
                    content: "\f105";
                    font-family: "Font Awesome 5 Free";
                    font-family: "Font Awesome 5 Free";
                    color: var(--primary-clr);
                    font-weight: 600;
                    font-size: 20px;
                }
            }

            .carousel-control-prev {
                left: var(--space);

                &::before {
                    content: "\f104";
                    font-family: "Font Awesome 5 Free";
                    color: var(--primary-clr);
                    font-weight: 600;
                    font-size: 20px;
                }
            }

            .carousel-indicators {
                z-index: 4;

                li {
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;

                    &.active {
                        background-color: var(--primary-clr);
                    }
                }
            }
        }

        .bottom-label {
            --label-space: calc(var(--space) + 1rem);
            bottom: var(--space);
            position: absolute;

            &.bottom-label-left {
                padding: 6px 16px;
                border-radius: 10px;
                background: rgba(255, 255, 255, 0.7);
                left: var(--label-space);
            }

            &.bottom-label-right {
                right: var(--label-space);

                .btn {
                    color: var(--primary-clr);
                    padding: 8px 16px;
                    border-radius: 10px;
                    border-radius: 10px;
                    background: #fff;
                }
            }
        }
    }

    .main-info-container {
        display: flex;
        align-items: center;
        margin: 1rem auto;

        .main-info {
            flex: 1;
            display: flex;
            align-items: center;

            .main-info__item {
                flex: 1;
                text-align: center;
                padding: 5px 0px;

                &:not(:last-child) {
                    border-right: 1px solid #d9d9d9;
                }

                h5 {
                    color: var(--primary-clr);
                    margin-bottom: 0px;
                    line-height: 1;
                }

                p {
                    font-weight: 500;
                    margin-bottom: 0px;
                }
            }
        }

        .price {
            flex-basis: 20%;
            text-align: right;

            h2 {
                color: var(--primary-clr);
            }
        }
    }

    .property-tabs-wrapper {
        background: #fff;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1),
            0px -1px 4px 0px rgba(0, 0, 0, 0.05);

        nav ul {
            display: flex;
            align-items: center;
            gap: 40px;
            margin-bottom: 0;

            a {
                display: inline-block;
                font-weight: 500;
                color: #6e6e73;
                padding: 10px 5px;

                &.active {
                    color: var(--primary-clr);
                    border-radius: 2px 2px 0px 0px;
                    border-bottom: 3px solid var(--primary-clr);
                }
            }
        }
    }

    .tabs-content-layout {
        display: grid;
        grid-template-columns: 1fr 350px;
        gap: 25px;

        aside {
            position: sticky;
            top: 80px;
            align-self: flex-start;
        }

        .left-section>section {
            padding: 50px 0px;
            border-bottom: 2px solid #e1e1e1;
        }
    }

    .fill-up-btn {
        border-radius: 50px 20px 20px 48px;
        background: #fff;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
        height: 100px;
        width: 100%;
        display: flex;
        align-items: center;
        font-size: 14px;
        gap: 25px;
        margin-bottom: 30px;

        span {
            flex: 1;
            text-align: initial;
        }

        &:hover {
            background: linear-gradient(294deg,
                    #E11F26 0%,
                    rgba(0, 97, 223, 0) 100%);
            box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
            color: #fff;
        }

        .img-container {
            width: 67px;
            height: 67px;
            border-radius: 50%;
            background-color: var(--primary-clr);
            position: relative;

            &:before,
            &:after {
                content: "";
                display: block;
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                border: 11px solid rgba(223, 0, 0, 0.7);
                border-radius: 50%;
            }

            &:before {
                animation: ripple 2s linear infinite;
            }

            &:after {
                animation: ripple 2s linear 1s infinite;
            }
        }

        @keyframes ripple {
            0% {
                transform: scale(1.1);
            }

            50% {
                transform: scale(1.5);
                opacity: 1;
            }

            100% {
                transform: scale(1.8);
                opacity: 0;
            }
        }
    }

    aside.right-section {
        padding-top: 50px;

        .info-blue-card {
            background: #eaf3ff;
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
            display: flex;
            align-items: center;
            padding: 16px;
            height: 100px;
            width: 100%;
            justify-content: space-between;
            margin-bottom: 18px;

            small {
                font-size: 12px;
                color: #575f6b;
            }

            p {
                font-size: 13px;
                font-weight: 500;
                color: #212121;
            }

            img {
                width: 52px;
            }

            &.co-investment-card {
                img {
                    width: 80px;
                }
            }
        }

        .premium_info {
            background-color: #EAF3FF;
            border-radius: 0.938rem;
            padding: 2.5rem;

            .lot_premium,
            .elevation_premium {

                .lot_premium_header,
                .elevation_premium_header {
                    color: #E11F26;
                    font-size: clamp(1rem, 1vw, 1.5rem);
                    font-weight: 500;
                    text-align: center;
                }
            }

        }
    }

    #property-overview {
        h3 {
            margin-bottom: 20px;
        }

        .property-overview__features {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 30px 20px;
            margin-bottom: 30px;

            label {
                font-size: 14px;
                color: #6e6e73;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }

            p {
                color: #323232;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                margin-bottom: 0px;
            }
        }

        .about-property-wrapper {
            position: relative;
            background: linear-gradient(180deg,
                    rgba(255, 255, 255, 0) 0%,
                    rgba(217, 217, 217, 0.59) 100%);
            padding: 10px;
            padding-bottom: 1.2rem;

            .about-property {
                margin-bottom: 0;
                height: 90px;
                overflow-y: hidden;

                &.full {
                    height: auto;
                }
            }

            .read-more-btn {
                display: inline-flex;
                padding: 6px 16px;
                justify-content: center;
                align-items: center;
                gap: 10px;
                border-radius: 16px;
                border: 1px solid #d1d1d1;
                background: #fff;
                font-size: 14px;
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translate(-50%, 50%);

                &>div {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                }
            }
        }
    }

    #explore-neighborhood {
        border-bottom-width: 0px;

        .map-view iframe {
            width: 100%;
            height: 250px;
            border-radius: 10px;
            background: lightgray 0px -56.807px / 100% 133.34% no-repeat;
            box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.1);
        }

        .neighborhood-features {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            row-gap: 40px;
            column-gap: 5px;
        }
    }

    #amenities-section {
        .amenities-list {
            display: grid;
            grid-template-columns: repeat(8, 1fr);
            row-gap: 40px;
            column-gap: 10px;
        }
    }

    .premium_info_desk {
        padding: 2.5rem;
        margin: 1rem 0;
        display: none;

        .lot_premium {
            .lot_premium_header {}
        }
    }

    #deposite_structure {
        .deposite_structure_container {
            display: grid;
            grid-template-columns: repeat(2, minmax(300px, 1fr));
        }
    }

    #property-details-section {
        ul {
            li {
                display: flex;
                align-items: center;

                b {
                    margin-left: 6px;
                    font-weight: 500;
                }
            }

            li::before {
                content: "";
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background-color: var(--primary-clr);
                margin-right: 14px;
            }
        }
    }

    //floor plan
    #Floor_plan {
        .Floor_container {
            display: flex;
            gap: 1rem;
            flex-wrap: wrap;
        }

        a {
            img {
                margin-right: 1rem;
            }
        }

        .Floor_plan_image {
            width: 7rem;
            height: 7rem;
            object-fit: cover;
            border-radius: 15px;
        }

        .Floor_plan {
            height: 75vh;
            width: 75vh;
        }
    }

    #facts-features-section {
        .facts-features-container {
            display: flex;
            gap: 30px;

            &>* {
                flex: 1;
            }
        }

        .facts-features-item {
            label {
                font-weight: 600;
                margin-bottom: 10px;
            }
        }
    }

    #virtual_tour {
        .video_controlers {
            position: relative;

            .video_play_button {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                z-index: 10;
                cursor: pointer;
            }

            #video {
                width: 100%;
                border-radius: 1rem;
            }
        }

    }

    #available-floor-plans {
        .plan-list {
            &>a {
                display: flex;
                gap: 1rem;
                align-items: center;
                padding: 15px 0px;
                padding-right: 50px;

                &:not(:last-child) {
                    border-bottom: 1px solid #d9d9d9;
                }

                img {
                    width: 80px;
                    height: 80px;
                    object-fit: cover;
                    border-radius: 10px;
                    background: #d9d9d9;
                }

                .plan-info {
                    p {
                        color: #13131a;
                        font-weight: 500;
                        margin-bottom: 10px;
                    }

                    ul {
                        display: flex;
                        align-items: center;
                        gap: 1rem;
                        color: #323232;
                        font-size: 15px;

                        li {
                            display: flex;
                            align-items: center;
                            gap: 10px;
                        }
                    }
                }

                .plan-action {
                    margin-left: auto;

                    i {
                        font-size: 20px;
                    }
                }
            }
        }
    }

    .circle-icon-with-title {
        --icon-wrapper-size: 42px;
        --icon-size: 25px;
        text-align: center;
        display: flex;
        align-items: center;
        flex-direction: column;
        gap: 12px;

        .icon-wrapper {
            background-color: #fff;
            border-radius: 50%;
            width: var(--icon-wrapper-size);
            height: var(--icon-wrapper-size);
            filter: drop-shadow(0px 2px 5px rgba(223, 0, 0, 0.2));
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                width: var(--icon-size);
                height: var(--icon-size);
            }
        }

        p {
            font-size: 13px;
        }
    }

    .new_property_details_bredc_content ul li.text-primary:before {
        display: none;
    }

    .nearby-schools-section {
        h3 {
            margin-bottom: 50px;
        }

        ul {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 30px;
            margin: 0;
            padding: 0;

            li {
                box-shadow: 0px 4px 4px 0px rgba(223, 26, 0, 0.15);
                padding: 30px 24px 24px 24px;

                p {
                    color: #414141;
                }

                p:first-of-type {
                    margin-bottom: 10px;
                }

                p:last-child {
                    margin-bottom: 0;
                }

                h4 {
                    font-size: 20px;
                    margin-bottom: 15px;
                }
            }
        }
    }

    .common-property-list-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(316px, 1fr));
        gap: 10px;
        overflow-x: auto;
        grid-auto-flow: column;
        padding-bottom: 1rem;
    }

    @media (max-width: 567px) {
        .premium_info_desk {
            display: block;
        }

        .new_property_details_bredc_content ul {
            li {
                font-size: 13px;

                &:not(:last-child) {
                    margin-right: 20px;

                    &:before {
                        right: -14px;
                        top: 0px;
                        font-size: inherit;
                    }
                }

                a {
                    font-size: inherit;
                }
            }
        }

        .new_property_details_bredc_content+.row {
            margin-bottom: 14px;
            align-items: center;

            h1 {
                font-size: 20px;
                line-height: normal;
                margin-bottom: 0;
            }

            p {
                margin-bottom: 0;
            }
        }

        .property-slider__container {
            padding: 0;

            #property-img {
                .carousel-item img {
                    height: 250px;
                    border-radius: 6.763px;
                }

                .carousel-indicators {
                    bottom: -17px;

                    li {
                        width: 6px;
                        height: 6px;
                    }
                }
            }

            .bottom-label.bottom-label-left {
                padding: 2.164px 4.328px;
                border-radius: 2.705px;
                left: 12px;
                bottom: 12px;
                font-size: 14px;
            }

            .bottom-label-right {
                // display:none;
                bottom: -6px;
                right: 16px !important;
                transform: translateY(100%);
                box-shadow: 0px 5px 5px 0px rgba(223, 0, 0, 0.1);
                border-radius: 7.545px;

                button {
                    padding: 6.036px 12.072px;
                }
            }
        }

        .price-container-mobile {
            padding-top: 13px;
            padding-bottom: 6px;

            h2 {
                font-size: 24px;
                color: var(--primary-clr);
            }
        }

        .main-info-container {
            .price {
                display: none;
            }

            .main-info__item {
                h5 {
                    font-size: 17px !important;
                }

                p {
                    font-size: 14px !important;
                    color: #6e6e73 !important;
                }
            }
        }

        .property-tabs-wrapper {
            box-shadow: none;
            gap: 0;

            ul {
                justify-content: space-between;
                gap: 0 !important;

                li {
                    a {
                        padding: 7px 0px;
                        font-size: 12px;
                    }
                }
            }
        }

        .tabs-content-layout {
            grid-template-columns: 1fr;
            // margin-bottom: 80px !important;

            .right-section {
                display: none;
            }

            h3 {
                font-size: 20px;
                text-align: center;
            }

            #property-overview {
                padding-bottom: 30px;
                border: none;
                padding-top: 15px;

                .property-overview__features {
                    grid-template-columns: repeat(3, 1fr);
                    gap: 15px 5px;
                    max-width: 100%;
                }

                .read-more-btn {
                    text-wrap: nowrap;
                }
            }

            #facts-features-section {
                padding-bottom: 0;
                border: none;

                .facts-features-container {
                    flex-wrap: wrap;
                    gap: 0;

                    &> :first-child {
                        flex-basis: 100%;
                    }
                }
            }

            #property-details-section {
                padding-top: 30px;
                padding-bottom: 0px;
                border: none;

                li {
                    align-items: flex-start;
                    margin-bottom: 8px;

                    b {
                        flex: 1;
                    }

                    &::before {
                        transform: translateY(8px);
                    }
                }
            }

            #amenities-section {
                padding: 0;
                padding-bottom: 10px;


                .amenities-list {
                    grid-template-columns: repeat(4, 1fr);
                    column-gap: 5px;
                }
            }

            #estimated-section {
                .estimated-card {
                    padding: 0;
                    background-color: transparent;
                }

                .estimated-card-header {
                    flex-direction: column;
                    gap: 15px;

                    p {
                        margin-bottom: 0;
                    }

                    font-size: 14px;
                }

                .estimated-slider-wrapper {
                    padding: 0px 45px;
                    border-radius: 15px;
                    height: 60px;
                    box-shadow: 0px 2px 25.41510009765625px rgba(255, 4, 4, 0.2);

                    .slider-bar {
                        height: 4px;

                        &::after,
                        &::before {
                            width: 10px;
                            height: 10px;
                        }
                    }

                    .slider-bar-ball.center {
                        width: 22px !important;
                        height: 22px !important;
                        box-shadow: 0px 22.058576583862305px 44.11715316772461px rgba(255, 4, 4, 0.2);
                        scale: 1.1;
                    }

                    .slider-price {
                        top: 62px;
                        font-size: 13px;
                        width: 90px;
                        height: 37px;
                        box-shadow: 0px 13.480216979980469px 26.960433959960938px rgba(255, 4, 4, 0.2);
                    }
                }
            }
        }

        .fill-up-btn {
            position: fixed;
            z-index: 2;
            bottom: 80px;
            background: transparent;
            box-shadow: none;
            width: auto;
            margin-bottom: 0;
            margin-right: 12px;
            margin-top: 5px;

            &:hover {
                background: transparent;
            }

            &:focus {
                border: none;
            }
        }

        h3.mb-30 {
            margin-bottom: 25px !important;
            font-size: 24px !important;
            text-align: center !important;
        }

        // &>section:last-of-type {
        //     margin-bottom: 80px !important;
        // }

        .nearby-schools-section {
            h3 {
                margin-bottom: 20px !important;
            }

            ul {
                display: grid;
                grid-template-columns: 1fr;

                h4 {
                    font-size: 17px !important;
                }
            }
        }

        #available-floor-plans {
            .plan-list {
                &>li {
                    gap: 12px;
                    padding: 15px 0px;
                    padding-right: 1rem;

                    img {
                        width: 70px;
                        height: 70px;
                        border-radius: 8px;
                    }

                    .plan-info {
                        p {
                            font-size: 14px;
                        }

                        ul {
                            gap: 0px;
                            font-size: 11px;

                            li {
                                gap: 5px;
                            }
                        }
                    }

                    .plan-action {
                        margin-left: auto;

                        i {
                            font-size: 20px;
                        }
                    }
                }
            }
        }

        .common-property-list-grid {
            display: flex !important;
            overflow-x: auto;
            padding-bottom: 20px;
            width: 100%;

            &>* {
                min-width: 100%;
            }

            &::-webkit-scrollbar-track {
                border-radius: 100px;
            }

            &::-webkit-scrollbar-thumb {
                -webkit-appearance: none;
                border-radius: 100px;
            }

            &::-webkit-scrollbar {
                height: 8px;
            }
        }

        .new_property_details_bredc_content ul {
            flex-wrap: wrap;
        }
    }
}
</style>

<style>
.sidebar_menu {
    top: 0px;
}
</style>
